export class Subscription {
    is_premium=false
    server_subscription_id=0
    is_premium_subscription_type=0
    server_enrolment_id=0
    level_name=""
    server_level_id:0
    name=""
    is_valid:false
    subject=""
}
